import {
  //ClearRefinements,
  SearchBox,
  connectRefinementList,
  connectNumericMenu,
} from "react-instantsearch-dom";
import { useRouter } from "next/compat/router";

import { slideToggle } from "@/helpers/userHelpers";
import styles from "../FiltersComp/Filter.module.scss";
import { colorCode , generalConstants } from "@/utils/constants";
import FilterWrapper from "./FilterWrapper";
import {orderBy} from 'lodash'
const RefinementList = ({
  items,
  isFromSearch,
  refine,
  searchForItems,
  createURL, lableFilter,
  hexCode, isColor,
  searchable, manualSort,brand_name }) => {
  if (!searchable && items.length == 0) return false

  // if(searchable){
  //   if(items.length == 1 ){
  //     searchable = false
  //   }
  // }
  const sortByPropertyLength = (property) => {
    return (a,b) => {  
       return a[property].length - b[property].length;  
    }  
  }

  const sortByProperty = (property) => {
    return (a,b) => {  
       if(a[property] > b[property])  {
          return 1;  
       } else if(a[property] < b[property]) {
        return -1;  
       }
       
       return 0;  
    }  
  }
  if(manualSort) {
    items = items.sort(sortByProperty('label'));
    items = items.sort(sortByPropertyLength('label'));
  }

  return (
    <>
    <FilterWrapper styles={styles} 
    lableFilter={lableFilter} 
    searchable={searchable}
    isColor={isColor}
    items={items}
    //CustomRangeInput={CustomRangeInput}
    hexCode={hexCode}
    brand_name={brand_name}
    isFromSearch={isFromSearch}
    slideToggle={slideToggle}
    refine={refine}
    colorCode={colorCode}
    searchForItems={searchForItems}
    />
    </>
  )
};

const CustomRefinementList = connectRefinementList(RefinementList);
const CustomNumericMenu = connectNumericMenu(RefinementList);
const capitalizeFirstLetter = (string) => {
  if(string) {
    string = string.toLowerCase()
    let split = string.split(',')
    split.forEach((value, i) => {
      let subValue = value.replaceAll('-', ' ').split(' ')
      let firstLetter = subValue[0].charAt(0).toUpperCase() + subValue[0].slice(1)
      subValue[0] = firstLetter
      split[i] = subValue.join(' ')
    })

    return split.join(',')
  }
  return ''
}


const FiltersCommonComp = (props) => {
  const router = useRouter();
  const { query } = router.query;
  let { pages = [] } = router.query;
  let params = pages.map((s) => decodeURI(s));
  let { brand,color,material,sleeves,heel_height,size,occasion } = router.query;
  const ISSERVER = typeof window === 'undefined'
  let brandLocal
  let colorLocal
  let materialLocal
  let sleevesLocal
  let heel_heightLocal
  let sizeLocal
  let priceLocal
  let occasionLocal
  if(!ISSERVER) {
    let pathnameRouter = router.pathname
    if(pathnameRouter === "/[...pages]") {
      pathnameRouter = router.query.pages.join('/')
    }
    brandLocal =  sessionStorage.getItem(`${pathnameRouter}~Brand`) || ''
    colorLocal =  sessionStorage.getItem(`${pathnameRouter}~Color`) || ''
    materialLocal =  sessionStorage.getItem(`${pathnameRouter}~Material`) || ''
    sleevesLocal =  sessionStorage.getItem(`${pathnameRouter}~Sleeves`) || ''
    heel_heightLocal =  sessionStorage.getItem(`${pathnameRouter}~Heel Height`) || ''
    sizeLocal =  sessionStorage.getItem(`${pathnameRouter}~Size`) || ''
    priceLocal = sessionStorage.getItem(`${pathnameRouter}~Price`) || ''
    occasionLocal = sessionStorage.getItem(`${pathnameRouter}~Occasion`) || ''
  }

  brand = handleBrandName(brand)
  color = capitalizeFirstLetter(color)
  material = capitalizeFirstLetter(material)
  sleeves = capitalizeFirstLetter(sleeves)
  heel_height = capitalizeFirstLetter(heel_height)
  size = capitalizeFirstLetter(size)
  occasion = capitalizeFirstLetter(occasion)

  if(props.brand_name) {
    brand = props.brand_name;
  }
  if(brandLocal) {
    brandLocal = brandLocal.toString()
    brand = brandLocal + (brand ? `,${brand}` : '')
  }
  if(brand) {
    brand = [...new Set(brand.split(','))];
  }
  if(colorLocal) {
    colorLocal = colorLocal.toString()
    color = colorLocal + (color ? `,${color}` : '')
  }
  if(color) {
    color = [...new Set(color.split(','))];
  }
  if(materialLocal) {
    materialLocal = materialLocal.toString()
    material = materialLocal+ (material ? `,${material}` : '')
  }
  if(material) {
    material = [...new Set(material.split(','))];
  }
  if(occasionLocal) {
    occasionLocal = occasionLocal.toString()
    occasion = occasionLocal+ (occasion ? `,${occasion}` : '')
  }
  if(occasion) {
    occasion = [...new Set(occasion.split(','))];
  }
  if(sleevesLocal) {
    sleevesLocal = sleevesLocal.toString()
    sleeves = sleevesLocal + (sleeves ? `,${sleeves}` : '')
  }
  if(sleeves) {
    sleeves = [...new Set(sleeves.split(','))];
  }
  if(heel_heightLocal) {
    heel_heightLocal = heel_heightLocal.toString()
    heel_height = heel_heightLocal + (heel_height ? `,${heel_height}` : '')
  }
  if(heel_height) {
    heel_height = [...new Set(heel_height.split(','))];
  }
  if(sizeLocal) {
    sizeLocal = sizeLocal.toString()
    size = sizeLocal + (size ? `,${size}` : '')
  }
  if(size) {
    size = [...new Set(size.split(','))];
  }
  if (priceLocal) {
    priceLocal = priceLocal
  }  
  
  let brandFilter = <CustomRefinementList attribute="vendor" searchable={true} lableFilter={"Brand"} brand_name={props.brand_name} defaultRefinement={brand || []}
 />;


  let colorFilter = <CustomRefinementList limit={25} attribute="meta.color.base_color" isColor={true} lableFilter={"Color"} hexCode={true} defaultRefinement={color || []}  transformItems={(items) =>
    orderBy(items, ['label', 'count'], ['asc', 'desc'])
  } />;
  
  if(colorCode.hide.includes(params[0])){
    colorFilter = "";
  }
 
  let sizeFilter = <CustomRefinementList limit={25} attribute="meta.custom.us_size" lableFilter={"Size"}  manualSort={"label"} defaultRefinement={size || []}
  transformItems={items =>
    items.map(item => ({
      ...item,
      // label: isNaN(item.label) ? item.label : item.label+' US',
    }))
  }
  />;
  let {styleFilterHeel , styleFilter , materialFilter } = "";
  let materialF = <CustomRefinementList limit={25} attribute="named_tags.Material" lableFilter={"Material"} defaultRefinement={material || []} 
  transformItems={(items) =>
    orderBy(items, ['label', 'count'], ['asc', 'desc'])
  } />;
  let occasionFilter = <CustomRefinementList limit={25} attribute="named_tags.Occasion" lableFilter={"Occasion"} defaultRefinement={occasion || []} 
  transformItems={(items) =>
    orderBy(items, ['count'], ['desc'])
  } />;

  let style = <CustomRefinementList limit={25} attribute="named_tags.Style > Sleeves" lableFilter={"Sleeves"} defaultRefinement={sleeves || []} 
  transformItems={(items) =>
    orderBy(items, ['label', 'count'], ['asc', 'desc'])
  } />;
  let style1 = <CustomRefinementList limit={25} attribute="named_tags.Style > Heel Height" lableFilter={"Heel Height "} defaultRefinement={heel_height || []} 
  transformItems={(items) =>
    orderBy(items, ['label', 'count'], ['asc', 'desc'])
  } />;

  if(generalConstants.show_material_filter.includes(params[0]) ||  generalConstants.show_material_filter.includes(props.selectedFilters.type) ){
    materialFilter = materialF;
  }
  
  if(generalConstants.show_style_sleeves_and_pattern.includes(params[0]) || generalConstants.show_style_sleeves_and_pattern.includes(params[1]) || generalConstants.show_style_sleeves_and_pattern.includes(props.selectedFilters.type)){
    styleFilter = style;
  }
  
  if(generalConstants.show_style_heels.includes(params[0]) || generalConstants.show_style_heels.includes(params[1]) || generalConstants.show_style_heels.includes(props.selectedFilters.type)){
    styleFilterHeel = style1;
  }

  let search = ""
  if (query) {
    search = <SearchBox defaultRefinement={query} />
  }

  
  let priceFilter = <CustomNumericMenu attribute="price" defaultRefinement={priceLocal}  items={[
    { label: 'price-range-input' ,},
    { label: '$200 and under',  end:200 },
    { label: '$300 and under',  end:300  },
    { label: '$500 and under',  end:500 },
    { label: '$1000 and under',  end:1000 },
    { label: '$1000 +',    start:1000 },
    ]}   lableFilter={"Price"}  />;

  return (
    <>
      <div className={`${props.styles.search_hidden} search_hide`}>
        {search}
      </div>
      {/* Brand Section */}
      {brandFilter}
      {/* End of Brand Section */}

      {/* Price Filter */}
      {priceFilter}
     
      {/* Color Section */}
      {colorFilter}

      {/* End of Color Section */}

      {/* Materials Section */}
      {materialFilter}

      {/* End of Materials Section */}

      {/* Size Section */}
      {sizeFilter}

      {/* End of Size Section */}

      {styleFilter}

      {styleFilterHeel}

      {occasionFilter}
    </>
  );
};

export default FiltersCommonComp;


const designers = {

  'acqua-di-parma': 'Acqua di Parma' ,
  'anna-new-york': 'ANNA New York' ,
  'ark-fine-jewelry': 'ARK Fine Jewelry' ,
  'atp-atelier': 'ATP Atelier' ,
  'az-factory': 'AZ Factory' ,
  'ba-sh': 'ba&sh' ,
  'beautystat': 'BeautyStat' ,
  'ben-amun': 'Ben-Amun' ,
  'bird-knoll': 'Bird & Knoll' ,
  'bvlgari': 'BVLGARI' ,
  'bytimo': 'byTiMo' ,
  'caalo': 'Caalo' ,
  'cherut-fine-jewelry': 'Chérut Fine Jewelry' ,
  'colbert-md': 'Colbert MD' ,
  'd-s-durga': 'D.S. & DURGA' ,
  'derm-institute': 'DERM iNSTITUTE' ,
  'dr-barbara-sturm': 'Dr. Barbara Sturm' ,
  'femmue': 'FEMMUE' ,
  'healthyline': 'HealthyLine' ,
  'heurueh': 'HEURUEH' ,
  'jac-jo': 'Jac + Jo' ,
  'jia-jia': 'JIA JIA' ,
  'joes-jeans': 'Joe\'s Jeans' ,
  'kimberly-mcdonald': 'Kimberly McDonald' ,
  'l-objet': 'L\'Objet' ,
  'la-doublej': 'La DoubleJ' ,
  'lab-to-beauty': 'Lab to Beauty' ,
  'larkspur-hawk': 'Larkspur & Hawk' ,
  'lvhr': 'LVHR' ,
  'macrene-actives': 'MACRENE Actives' ,
  'marei1998': 'Marei1998' ,
  'mita-eyewear': 'MITA Eyewear' ,
  'mks-jewellery': 'MKS Jewellery' ,
  'mz-skin': 'MZ Skin' ,
  'nevernot': 'NeverNoT' ,
  'nion': 'NION' ,
  'olympia-le-tan': 'Olympia Le-Tan' ,
  'oxomio': 'OXOMIO' ,
  'preen-by-thornton-bregazzi-home': 'Preen by Thornton Bregazzi Home' ,
  'rag-bone': 'rag & bone' ,
  'revive': 'RéVive' ,
  'royce-new-york': 'ROYCE New York' ,
  's-joon': 'S.Joon' ,
  'sachin-babi': 'Sachin and Babi' ,
  'semsem': 'SemSem' ,
  'short-suite': 'Short & Suite' ,
  'shymi': 'SHYMI' ,
  'sio-beauty': 'SiO Beauty' ,
  'solid-striped': 'Solid & Striped' ,
  'strialite': 'STRIALITE',
  'stubbs-wootton': 'Stubbs & Wootton',
  "r-co": "R+Co",
  "spinelli-kilcollin":"Spinelli Kilcollin",
  "dr-lara-devgan": "Dr. Lara Devgan",
  "dr-loretta": "Dr. Loretta",
  "the-vampires-wife": "The Vampire's Wife",
  "soia-kyo": "Soia & Kyo",
  "maha-morena": "MÄHA & MORENA",
  "stripe-stare": "Stripe & Stare",
}

function handleBrandName(name) {
  
  if(!name) {
    return ''
  }
  name = name.toLowerCase()
  let splitedName = name.toString().split(',')
  splitedName.forEach((value, index) => {

    if(designers[value]) {
      splitedName[index] = designers[value]
    } else {

      let subValue = value.replaceAll('-', ' ').split(' ')
      subValue = subValue.map(v => v.charAt(0).toUpperCase() + v.slice(1)).join(' ')
      splitedName[index] = subValue
    }
  })
  return splitedName.join(',')
}
